import React from 'react'
import '../pages/css/Home.css';
import Fintech1 from '../images/fintech1.jpg';
import Fintech2 from '../images/fintech2.jpeg';
import Fintech3 from '../images/fintech3.avif';
import banner from '../images/fintech_banner.png';

function Fintech() {
    return (
        <>   <section
            id="contact-section-page"
            style={{
                backgroundImage: `url(${banner})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                position: 'relative', // Important for overlay
                zIndex: 1,
            }}
        >
            {/* Overlay */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)', // semi-transparent black
                    zIndex: 2,
                }}
            ></div>

            <section className="container-fluid px-3 px-md-5 pt-3 pb-5" style={{ position: 'relative', zIndex: 3 }}>
                <div className="row justify-content-center text-center">
                    <div className="col-lg-10">
                        <h1 className="fw-bold display-5 text-white" style={{ fontSize: '4.5rem' }}>Fintech Solutions
                        </h1>
                        <p className="fs-2 fw-medium text-white mt-3">
                           We develop secure, scalable fintech and insurtech platforms to streamline transactions, automate workflows, and enhance customer trust and compliance.
                        </p>
                    </div>
                </div>
            </section>
        </section>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">Our  <span className="highlight-orange">Fintech</span> Services
                    </div>
                </div>
            </section>

            <section className="container my-5">
                {/* Fintech Software Solutions */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={Fintech1}
                            alt="Fintech Software Solutions"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Fintech</span> Software Development
                        </h1>
                        <p className="mb-4">
                            <h2>Transforming finance through secure, scalable, and customer-centric digital platforms.</h2>
                        </p>

                        <h6 className="fw-bold mb-2 highlight-orange">Key Highlight:</h6>
                        <p className="mb-4 ps-3">
                            <h4>We deliver cutting-edge fintech apps, payment gateways, digital wallets, and AI-powered analytics for banks, startups, and financial institutions.</h4>
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Insurtech Platforms */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Insurtech</span> Platforms
                        </h1>

                        <p className="mb-4">
                            <h2>Streamline policy management, underwriting, and claims processing with advanced insurtech systems tailored to insurers and agencies.</h2>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Policy Management Systems</h4>
                        <p className="mb-2 ps-3">
                            <h5>Develop custom platforms for automated policy creation, renewal, and tracking with secure client dashboards.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Digital Claims Processing</h4>
                        <p className="mb-2 ps-3">
                            <h5>Enable real-time claim filing, document upload, and AI-based fraud detection for a seamless claims lifecycle.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Underwriting Automation</h4>
                        <p className="mb-2 ps-3">
                            <h5>Leverage AI to assess risk profiles, score applications, and improve underwriting speed and accuracy.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Customer Portals</h4>
                        <p className="mb-2 ps-3">
                            <h5>Build self-service portals with policy access, premium payment, and support chatbots for better engagement.</h5>
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={Fintech2}
                            alt="Insurtech Platform Development"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* AI & Blockchain for Fintech */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={Fintech3}
                            alt="AI and Blockchain in Finance"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">AI & Blockchain</span> in Finance
                        </h1>

                        <p className="mb-4">
                            <h2>Unlock the future of finance with intelligent automation and decentralized security solutions.</h2>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">AI-Based Credit Scoring</h4>
                        <p className="mb-2 ps-3">
                            <h5>Implement machine learning models for real-time credit risk assessments using alternative data sources.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Fraud Detection Systems</h4>
                        <p className="mb-2 ps-3">
                            <h5>Use AI to detect anomalies in transactions, user behavior, and account access to prevent financial fraud.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Blockchain-Based Transactions</h4>
                        <p className="mb-2 ps-3">
                            <h5>Enable secure, immutable, and transparent transactions using distributed ledger technologies like Ethereum or Hyperledger.</h5>
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>
            </section>

        </>

    )
}

export default Fintech;